import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  faucltyArr
  alex_branch
  main_branch
  branches
  youtube : ""
  facebook : ""
  tiwtter : ""
  bank : ""
  instgram : ""
  modelLink : ""
  CENTERLIBGATE_LINK 
  list_condtion: any;
  buildingArr: any;
  constructor(private rest: RestService , private route : Router) { }

  ngOnInit(): void {

    this.rest.GetBranchesFaculties().subscribe((res: any) => {
      this.buildingArr = res.academy_constructions
      this.branches = res.branches
      this.instgram = res.INSTAGRAME
      this.facebook = res.FACRBOOK
      this.tiwtter = res.TWITTER
      this.youtube = res.YOUTUBE
      this.bank = res.INFO_BANK
      this.modelLink = res.MOODLE_LINK
      this.CENTERLIBGATE_LINK = 'http://library.aoa.edu.eg/'
      for (let i = 0; i < this.branches.length; i++) {
        for (let j = 0; j < this.branches[i].faculty.length; j++) {
          this.branches[i].faculty[j].branch_id = this.branches[i].branch_id
        }
      }
      this.alex_branch = this.rest.orderFaculties(this.branches[1].faculty)
      this.main_branch = this.rest.orderFaculties(this.branches[0].faculty)
    })

    this.rest.homePage().subscribe((res: any) => {
      this.faucltyArr = this.rest.orderFaculties(res.faculty)

    })
  }

  gotToFaculty(item){
    localStorage.setItem('FACULTY_NAME', item.FACULTY_NAME)
    localStorage.setItem("facultyId",item.ID)
    localStorage.setItem("DATE_ESTABLISH",item.DATE_ESTABLISH)
    localStorage.setItem("faculty_image",item.SLIDER_IMAGE)
    localStorage.setItem('branch_id', item.branch_id)
    this.openFacultySite(item)
  }

  // Every institute lives on its own subdomain and resolves itself from the
  // hostname, so we send the user to that subdomain's root. The Alexandria
  // branch (branch_id 6) has separate "-alx" subdomains.
  openFacultySite(item){
    const mainBranch = {
      8: 'himc', 11: 'hib', 12: 'hic', 13: 'hita', 14: 'hiam',
      15: 'hifa', 16: 'hiac', 17: 'hica', 19: 'hialamt'
    }
    const alexBranch = {
      12: 'hic-alx', 13: 'hita-alx', 16: 'hiac-alx', 15: 'hifa-alx'
    }
    const map = (item.branch_id == 6) ? alexBranch : mainBranch
    const sub = map[item.ID]
    if (sub) {
      window.location.href = 'https://' + sub + '.aoa.edu.eg/'
    }
  }

  gotToConstrction(item){
    // Mapped activities live on their own subdomain; send the user there.
    // Anything without a subdomain still falls back to in-app id routing.
    if (this.rest.constructionSubdomains[item.ID]) {
      this.rest.openConstructionSite(item)
      return
    }
    this.route.navigate(['/constrction', item.ID]).then(() => {
      location.reload()
    })
  }

}
